export default {
  UP: 'up-small-for-nav-item',
  DOWN: 'down-small-for-nav-item',
};
